import styled from 'styled-components/macro';
import { distances } from '../styles/constants';

export const Ul = styled.ul`
    margin: ${distances.small};
    padding: 0;
    @media (max-width: 400px) {
        margin-bottom: 0;
    }
`;

export const Li = styled.li`
    margin:0;
    padding: 0 0 0 ${distances.small};
`;

